import { render } from "./RecordsView.vue?vue&type=template&id=f297d394&scoped=true"
import script from "./RecordsView.vue?vue&type=script&lang=js"
export * from "./RecordsView.vue?vue&type=script&lang=js"

import "./RecordsView.vue?vue&type=style&index=0&id=f297d394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f297d394"]])

export default __exports__